/*
*Actions constants for search data(header functionality)

*/
export const FETCH_SEARCH_DATA = "FETCH_SEARCH_DATA";
export const RECIEVE_SEARCH_DATA = "RECIEVE_SEARCH_DATA";

//Action constants for search data childsays(header functionality)
export const FETCH_CHILDSAY_DATA = "FETCH_CHILDSAY_DATA";
export const RECIEVE_CHILDSAY_DATA = "RECIEVE_CHILDSAY_DATA";

//Action constants for noftifications
export const FETCH_NOTIFICATIONS = "FETCH_NOTIFICATIONS";
export const RECIEVE_NOTIFICATIONS = "RECIEVE_NOTIFICATIONS";

//Action constants for noftificationsstatus
export const FETCH_NOTIFICATIONS_STATUS = "FETCH_NOTIFICATIONS_STATUS";
export const RECIEVE_NOTIFICATIONS_STATUS = "RECIEVE_NOTIFICATIONS_STATUS";

//Action constants for noftificationsremovestatus
export const FETCH_REMOVED_NOTIFICATIONS_STATUS =
  "FETCH_REMOVED_NOTIFICATIONS_STATUS";
export const RECIEVE_REMOVED_NOTIFICATIONS_STATUS =
  "RECIEVE_REMOVED_NOTIFICATIONS_STATUS";

//Action constants for noftificationsunfollowstatus
export const FETCH_UNFOLLOW_NOTIFICATIONS_STATUS =
  "FETCH_UNFOLLOW_NOTIFICATIONS_STATUS";
export const RECIEVE_UNFOLLOW_NOTIFICATIONS_STATUS =
  "RECIEVE_UNFOLLOW_NOTIFICATIONS_STATUS";

//Action constants for feeddata
export const FETCH_FEED_DATA = "FETCH_FEED_DATA";
export const RECIEVE_FEED_DATA = "RECIEVE_FEED_DATA";

//Action constants for followunfollowstatus
export const FETCH_FOLLOW_DATA = "FETCH_FOLLOW_DATA";
export const RECIEVE_FOLLOW_DATA = "RECIEVE_FOLLOW_DATA";

//Action constants for followunfollowstatus
export const FETCH_VOTEUP_STATUS = "FETCH_VOTEUP_STATUS";
export const RECIEVE_VOTEUP_STATUS = "RECIEVE_VOTEUP_STATUS";

//Action constants for postfollowercount
export const FETCH_FOLLOWER_COUNT = "FETCH_FOLLOWER_COUNT";
export const RECIEVE_FOLLOWER_COUNT = "RECIEVE_FOLLOWER_COUNT";

//Action constants for Deleting a post
export const FETCH_DELETE_STATUS = "FETCH_DELETE_STATUS";
export const RECIEVE_DELETE_STATUS = "RECIEVE_DELETE_STATUS";

//Action constants for status of a report
export const FETCH_REPORT_STATUS = "FETCH_REPORT_STATUS";
export const RECIEVE_REPORT_STATUS = "RECIEVE_REPORT_STATUS";

//Action constants for sending a report data
export const FETCH_REPORT_DATA = "FETCH_REPORT_DATA";
export const RECIEVE_REPORT_DATA = "RECIEVE_REPORT_DATA";

//Action constants for posting childsay
export const POST_CHILDSAY_DATA = "POST_CHILDSAY_DATA";
export const RECIEVE_RESPONSE_OF_POSTED_CHILDSAY_DATA =
  "RECIEVE_RESPONSE_OF_POSTED_CHILDSAY_DATA";

//Action constants for sending a mail to specific person
export const POST_A_MAIL_DATA = "POST_A_MAIL_DATA";
export const RECIEVE_RESPONSE_OF_A_MAIL_DATA =
  "RECIEVE_RESPONSE_OF_A_MAIL_DATA";

//Action constants for Edit a Post
export const EDIT_A_POST = "EDIT_A_POST";
export const RECIEVE_RESPONSE_OF_EDIT_A_POST =
  "RECIEVE_RESPONSE_OF_EDIT_A_POST";

//Action constants for fetching near by communitys
export const FETCH_NEAR_BY_COMMUNITYS = "FETCH_NEAR_BY_COMMUNITYS";
export const RECIEVE_NEAR_BY_COMMUNITYS = "RECIEVE_NEAR_BY_COMMUNITYS";
export const GET_NEAR_BY_COMMUNITYS = "GET_NEAR_BY_COMMUNITYS";

//Action constants for edit a update
export const EDIT_A_UPDATE = "EDIT_A_UPDATE";
export const RESPONSE_OF_EDIT_A_UPDATE = "RESPONSE_OF_EDIT_A_UPDATE";

// Action constants for Email actions via Templates:
export const SET_EMAIL_ACTION = "SET_EMAIL_ACTION";
export const CLEAR_EMAIL_ACTION = "CLEAR_EMAIL_ACTION";

//Action Constants for SignIn Actions
export const DO_SIGNIN = " DO_SIGNIN";
export const RECEIVE_SIGN_IN_DATA = "RECEIVE_SIGN_IN_DATA";
export const FETCH_SIGNIN_STATUS = "FETCH_SIGNIN_STATUS";
export const RECEIVE_LAND_API_DATA = "RECEIVE_LAND_API_DATA";
export const RECIEVE_SIGNIN_STATUS = "RECIEVE_SIGNIN_STATUS";
export const AUTHORIZED_USER = "AUTHORIZED_USER";
export const UNAUTHORIZED_USER = "UNAUTHORIZED_USER";
export const NEW_USER = "NEW_USER";
export const LOADING_VALUE = " LOADING_VALUE";
export const LOADING_VALUE_STOP = " LOADING_VALUE_STOP";
export const SiGNoUT_STATUS = "SiGNoUT_STATUS";
export const SIGNOUT = " SIGNOUT";
export const UPDATE_IS_NEW_USER = "UPDATE_IS_NEW_USER";
export const SET_AUTHENTICATING = "SET_AUTHENTICATING";
export const RESET_MODERATOR_COUNT = "RESET_MODERATOR_COUNT";
export const RESET_NOTIFICATION_COUNT = "RESET_NOTIFICATION_COUNT";

//change a communty
export const CHANGE_COMMUNITY = "CHANGE_COMMUNITY";
export const RESPONSE_OF_CHANGE_COMMUNITY = "RESPONSE_OF_CHANGE_COMMUNITY";

//contributors
export const FETCH_CONTRIBUTORS = "FETCH_CONTRIBUTORS";
export const RECEIVE_CONTIRBUTORS_RESPONSE = "RECEIVE_CONTIRBUTORS_RESPONSE";

//Edit Bio
export const FETCH_EDIT_BIO = "FETCH_EDIT_BIO";
export const RECEIVE_EDIT_BIO_RESPONSE = "RECEIVE_EDIT_BIO_RESPONSE";

//Asks u can answer
export const FETCH_SAY_ASK_DATA = "FETCH_SAY_ASK_DATA";
export const RECIEVE_SAY_ASK_DATA = "RECIEVE_SAY_ASK_DATA";

//Sayss u can answer
export const FETCH_ASK_SAY_DATA = "FETCH_ASK_SAY_DATA";
export const RECIEVE_ASK_SAY_DATA = "RECIEVE_ASK_SAY_DATA";

//settings
export const FETCH_SETTINGS = "FETCH_SETTINGS";
export const RECIEVE_SETTINGS = "RECIEVE_SETTINGS";

//@username
export const FETCH_USERNAME = "FETCH_USERNAME";
export const RECIEVE_USERNAME = "RECIEVE_USERNAME";

//Ask your community
export const ASK_YOUR_COMMUNITY = "ASK_YOUR_COMMUNITY";
export const RECIEVE_ASK_YOUR_COMMUNITY = "RECIEVE_ASK_YOUR_COMMUNITY";

//get multiple communitys
export const GET_MODERATE_COMMUNITYS = "GET_MODERATE_COMMUNITYS";
export const RECIEVE_MODERATE_COMMUNITYS = "RECIEVE_MODERATE_COMMUNITYS";

//hashtag check
export const FETCH_HASH = "FETCH_HASH";
export const RECIEVE_HASH = "RECIEVE_HASH";
export const NEW_HASH = "NEW_HASH";

//hash(#) Check
export const GET_HASH_CHECK = "GET_HASH_CHECK";
export const RECIEVE_HASH_CHECK = "RECIEVE_HASH_CHECK";
export const NOT_HASH = "NOT_HASH";
export const EXISTING_HASH = "EXISTING_HASH";

//post tag
export const GET_POST_TAG = "GET_POST_TAG";
export const RECIEVE_POST_TAG = "RECIEVE_POST_TAG";

//post Update
export const GET_UPDATE_POST = "GET_UPDATE_POST";
export const RECIEVE_UPDATE_POST = "RECIEVE_UPDATE_POST";

// Action Constants for Treding Tags
export const FETCH_TAG_DATA = "FETCH_TAG_DATA";
export const RECIEVE_TAG_DATA = "RECIEVE_TAG_DATA";

// Action Constants for Treding Asks
export const FETCH_ASKS_DATA = "FETCH_ASKS_DATA";
export const RECIEVE_ASKS_DATA = "RECIEVE_ASKS_DATA";

//Action Constans for Dispaly the Trending tag
export const FETCH_SAY_TAG_DATA = "FETCH_SAY_TAG_DATA";
export const RECIEVE_SAY_TAG_DATA = "RECIEVE_SAY_TAG_DATA";

//Action Constans for ContactMessagePost
export const GET_CONTACT_SUBMIT = "GET_CONTACT_SUBMIT";
export const RECIEVE_CONTACT_SUBMIT = "RECIEVE_CONTACT_SUBMIT";

//Action Start Community Dispalying Data
export const FETCH_COMMUNITYINFO_DATA = "FETCH_COMMUNITYINFO_DATA";
export const RECIEVE_COMMUNITYINFO_DATA = "RECIEVE_COMMUNITYINFO_DATA";

//Action Constants for Dispalying the Profile Details
export const FETCH_PROFILE_DATA = "FETCH_PROFILE_DATA";
export const RECIEVE_PROFILE_DATA = " RECIEVE_PROFILE_DATA";

//Action Constants for Dispalying Updated Profile Details
export const UPDATE_PROFILE_INFO = "UPDATE_PROFILE_INFO";
export const RECEIVE_UPDATED_PROFILE_INFO = "RECEIVE_UPDATED_PROFILE_INFO";

//Actions for Activity Page
export const FETCH_ACTIVITY_DATA = "FETCH_ACTIVITY_DATA";
export const RECIEVE_ACTIVITY_DATA = "RECIEVE_ACTIVITY_DATA";

//New forgot password action constanst
export const FETCH_NEW_FORGOT_PASS = "FETCH_NEW_FORGOT_PASS";
export const RECEIVE_NEW_FORGOT_PASS = "RECEIVE_NEW_FORGOT_PASS";

//.................................................................//

//  ...........................MODERATOR..................

//Action constants  To display the list of communities that user is moderating
export const FETCH_MODERATING_COMMUNITYS_LIST =
  "FETCH_MODERATING_COMMUNITYS_LIST";
export const RECIEVE_MODERATING_COMMUNITYS_LIST =
  "RECIEVE_MODERATING_COMMUNITYS_LIST";

//Action constants to get the timeline images
export const FETCH_TIMELINE_IMAGES_LIST = "FETCH_TIMELINE_IMAGES_LIST";
export const RECIEVE_TIMELINE_IMAGES_LIST = "RECIEVE__TIMELINE_IMAGES_LIST";

//Action constants for photo upload
export const UPLOAD_PHOTO_TO_PHOTO_TIMELINE = "UPLOAD_PHOTO_TO_PHOTO_TIMELINE";
export const RECIEVE_UPLOAD_PHOTO_STATUS = "RECIEVE_UPLOAD_PHOTO_STATUS";

//Action constants for tenantlist
export const FETCH_TENANT_LIST = "FETCH_TENANT_LIST";
export const RECIEVE_TENANT_LIST = "RECIEVE_TENANT_LIST";
export const GET_TENANT_LIST = "GET_TENANT_LIST";

//Action Constants for delete timeline images
export const DELETE_TIMELINE_IMAGE = "DELETE_TIMELINE_IMAGE";
export const RECIEVE_DELETE_TIMELINE_IMAGE_RESPONSE =
  "RECIEVE_DELETE_TIMELINE_IMAGE_RESPONSE";

//Action Constants for update timeline images desc
export const UPDATE_TIMELINE_IMAGE_DESC = "UPDATE_TIMELINE_IMAGE_DESC";
export const RECIEVE_TIMELINE_IMAGE_DESC_UPDATE_RESPONSE =
  "RECIEVE_TIMELINE_IMAGE_DESC_UPDATE_RESPONSE";

//Action Constants Managemebers community moderator section
export const FETCH_MANAGE_MEMBERS_DATA = "FETCH_MANAGE_MEMBERS_DATA";
export const RECIEVE_MANAGE_MEMBERS_DATA = "RECIEVE_MANAGE_MEMBERS_DATA";
export const MANAGE_MEMBERS_LOADING = "MANAGE_MEMBERS_LOADING";

// Action Constants Managemebers Block members community moderator section
export const FETCH_BLOCK_MEMBERS_DATA = "FETCH_BLOCK_MEMBERS_DATA";
export const RECIEVE_BLOCK_MEMBERS_DATA = "RECIEVE_BLOCK_MEMBERS_DATA";

// Action Constants Managemebers getBlockusersdata in members community moderator section

export const FETCH_BLOCKED_USERS_DATA = " FETCH_BLOCKED_USERS_DATA";
export const RECIEVE_BLOCKED_USERS_DATA = "RECIEVE_BLOCKED_USERS_DATA";

// Manage members community warnUserCommunity in members moderators actions

export const FETCH_WARN_USER_COMMUNITY = " FETCH_WARN_USER_COMMUNITY";
export const RECIEVE_WARN_USER_COMMUNITY = "RECIEVE_WARN_USER_COMMUNITY";

// Manage members community Invite Members in submenu of ManageMembers actions
export const FETCH_INVITE_MEMBERS_DATA = " FETCH_INVITE_MEMBERS_DATA";
export const RECIEVE_INVITE_MEMBERS_DATA = "RECIEVE_INVITE_MEMBERS_DATA";

// Manage members community Invite as Moderator in submenu of ManageMembers actions
export const FETCH_INVITE_AS_MODERATOR = " FETCH_INVITE_AS_MODERATOR";
export const RECIEVE_INVITE_AS_MODERATOR = "RECIEVE_INVITE_AS_MODERATOR";

// Manage members community Remove as Moderator in submenu of ManageMembers actions
export const FETCH_REMOVE_AS_MODERATOR = " FETCH_REMOVE_AS_MODERATOR";
export const RECIEVE_REMOVE_AS_MODERATOR = "RECIEVE_REMOVE_AS_MODERATOR";

//////Manage content Modearator section  calls start from here

//Manage content community ActionItems in Moderator
export const FETCH_ACTION_ITEMS_DATA = "FETCH_ACTION_ITEMS_DATA";
export const RECIEVE_ACTION_ITEMS_DATA = "RECIEVE_ACTION_ITEMS_DATA";

//Manage content community PrivateTags in Moderator
export const FETCH_PRIVATE_TAG_DATA = "FETCH_PRIVATE_TAG_DATA";
export const RECIEVE_PRIVATE_TAG_DATA = "RECIEVE_PRIVATE_TAG_DATA";

//Manage content community ActivityLog in Moderator
export const FETCH_ACTIVITY_LOG_DATA = "FETCH_ACTIVITY_LOG_DATA";
export const RECIEVE_ACTIVITY_LOG_DATA = "RECIEVE_ACTIVITY_LOG_DATA";

export const UPDATE_COMMUNITY_RULE = "UPDATE_COMMUNITY_RULE";

//Edit community Update maps boundaries data
export const FETCH_UPDATE_MAPS_BOUNDARIES_DATA =
  "FETCH_UPDATE_MAPS_BOUNDARIES_DATA";
export const RECIEVE_UPDATE_MAPS_BOUNDARIES_DATA =
  "RECIEVE_UPDATE_MAPS_BOUNDARIES_DATA";
